import React from 'react';
import { useContext, useEffect, useState } from "react";
import { AND, OR } from "../../misc/RuleObjectTypes";
import { RulesContext } from "../../RulesContext";

const ConditionOperator = ({ element, position }) => {
  const { ruleDispatch, ruleState } = useContext(RulesContext);
  const [subConditionOp, setSubConditionOp] = useState(AND);
  useEffect(() => {
    setSubConditionOp(element.subConditionOp);
  });

  return (
    <div>
      <div className="condition-operator">
        <select data-testid="rule-condition-operator-select"
          className='form-select drop-down-dm tw-w-[6%] shadow-none tw-border tw-border-edge tw-bg-surface tw-rounded tw-font-medium tw-text-sm tw-text-ink-tertiary tw-px-2 tw-py-1'
          value={subConditionOp}
          onChange={(el) =>
            ruleDispatch({
              type: "SET_COND_OP",
              subConditionOp: el.target.value,
              position: position,
            })
          }
        >
          <option value={AND}>And</option>
          <option value={OR}>Or</option>
        </select>
      </div>
      <div className="separator" />
    </div>
  );
};
export default ConditionOperator;
